interface User {
  subscription?: {
    account_type?: string;
  };
}

export const hasSchoolOrDistrictPremium = (user: User): boolean => {
  const subscriptionType = user.subscription?.account_type;
  return subscriptionType?.includes('School') || subscriptionType?.includes('District') || false;
}
